module.exports = __webpack_public_path__ + "media/images/exclamation-8d6161fe70f807f03b877b1d36f8def3.png";